import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown from '../../../../../../components/Dropdown/Dropdown';
import { useAppDispatch, useAppSelector } from '../../../../../../reduxService/hooks';
import { MaterialType } from '../../../../../enum/Material';
import { fetchMaterialsByType, fetchStillingBasingMaterials, selectMaterial } from '../../../../../store/material/materialSlice';
import './MaterialDropdownsList.scss';
import { selectProject } from '../../../../selector/conversion';
import { get } from 'lodash';
import { IFormikForm } from '../ModalMaterial/FormikMaterial';
import { useFormikContext } from 'formik';
import { t } from 'i18next';
interface IMaterialTypeDropdown {
    isMacra2?: boolean;
}

export const materialTypeOptions = () => [
    { label: t('materialType_protectionSystems'), value: MaterialType.ProtectionSystems },
    { label: t('materialType_naturalSoils'), value: MaterialType.NaturalSoils },
    { label: t('materialType_soilBioengineeringNaturalVegetation'), value: MaterialType.SoilBioengineeringNaturalVegetation },
];
export const MaterialTypeDropdown = (props: IMaterialTypeDropdown) => {
    const { t } = useTranslation();
    const { isMacra2 } = props;
    const dispatch = useAppDispatch();
    const materials = useAppSelector(selectMaterial);
    const project = useAppSelector(selectProject);
    const { values } = useFormikContext<IFormikForm>();
    let geometry = get(project, 'data.geometry', []);
    let geo = geometry.find(geo => geo.channel === values.sectorChannel);
    let matType = get(geo, 'material.type', MaterialType.ProtectionSystems);

    const [type, setType] = useState<MaterialType>(matType);

    //callback
    const changeType = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
        const type: any = e.target.value;
        setType(type);
    }, []);
    //effect
    useEffect(() => {
        if (matType !== type) {
            setType(matType);
        }
    }, [matType]);
    //effect
    useEffect(() => {
        if (!materials.pending && !isMacra2) {
            dispatch(fetchMaterialsByType(type));
        }
    }, [type]);

    return (
        <div className='material-dropdown-wrapper'>
            <Dropdown title={t('modal_material_dropdown')} name='type' className='d-flex flex-column' defaultValue={type} options={materialTypeOptions()} onChange={changeType} />
        </div>
    );
};
